module.exports = __webpack_public_path__ + "img/home-service-ruanjian.7481f781.png";